export const AB_TEST_PAYMENT_SCREEN_VIDEO = 'platba-skip-pay_video';
export const AB_TEST_PUBLIC_REGISTRATION_CTA_TEXTS = 'public-registration-cta-texts';
export const AB_TEST_OVERVIEW_MAXI_BUTTONS = 'overview-maxi-buttons';
